import { type ComponentConfig } from "@puckeditor/core";
import { Breadcrumb, type BreadcrumbProps } from "./breadcrumb";
import { BreadcrumbFields } from "./breadcrumb.fields";

export const BreadcrumbConfig: ComponentConfig<BreadcrumbProps> = {
  label: "Breadcrumb",
  fields: {
    showHomeIcon: BreadcrumbFields.showHomeIcon,
    separator: BreadcrumbFields.separator,
    items: BreadcrumbFields.items as any,
  },
  defaultProps: {
    showHomeIcon: true,
    separator: "chevron",
    items: [
      { label: "Home", url: "/" },
      { label: "Services", url: "/services/" },
      { label: "Current Page", url: "" },
    ],
  },
  render: ({ id, puck, editMode, ...props }) => {
    const siteUrl: unknown = puck?.metadata?.site?.url;

    return <Breadcrumb id={id} {...props} baseUrl={typeof siteUrl === "string" ? siteUrl : undefined} />;
  },
};
